/* ==========================================================================
   ET - Warranty
   Accordion toggle with per-breakpoint default-open state.
   - No-flash init: initial state applied without transition.
   - Respects the merchant's "open by default" settings (split desktop/mobile).
   - Re-syncs to the breakpoint default on resize until the user interacts.
   - Theme-editor aware (block select / section + block load).
   ========================================================================== */
(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 749px)';

  function init(el) {
    if (!el || el.__etWarranty) return;
    var btn = el.querySelector('[data-et-warranty-toggle]');
    if (!btn) return;
    el.__etWarranty = true;

    var mq = window.matchMedia(MOBILE_MQ);
    var userToggled = false;

    function defaultOpen() {
      var attr = mq.matches
        ? el.getAttribute('data-open-mobile')
        : el.getAttribute('data-open-desktop');
      return attr === 'true';
    }

    function setOpen(open, animate) {
      if (!animate) el.classList.add('et-warranty--no-anim');
      el.classList.toggle('is-open', !!open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!animate) {
        /* force reflow so the no-transition state is committed before re-enabling */
        void el.offsetHeight;
        el.classList.remove('et-warranty--no-anim');
      }
    }
    el.__etWarrantyOpen = setOpen;

    /* Initial state — no animation on first paint */
    setOpen(defaultOpen(), false);

    btn.addEventListener('click', function () {
      userToggled = true;
      setOpen(!el.classList.contains('is-open'), true);
    });

    var onChange = function () {
      if (!userToggled) setOpen(defaultOpen(), false);
    };
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[data-et-warranty]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:block:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-et-warranty]') : null;
    if (!el) return;
    init(el);
    if (el.__etWarrantyOpen) el.__etWarrantyOpen(true, true);
  });
})();
